const TZ = "Europe/Athens";
const pad = (n) => String(n).padStart(2, "0");
const ymd = (iso) => iso.replace(/-/g, "");
const addHours = (hhmm, h) => { const [H, M] = hhmm.split(":").map(Number); return `${pad(H + h)}${pad(M)}00`; };
const esc = (t) => t.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");

const eventOf = (d, label) => {
  const start = d.time || "08:30";
  const hours = /6 ώρες/.test(d.items.map((i) => i.s).join(" ")) ? 6 : /4 ώρες/.test(d.items.map((i) => i.s).join(" ")) ? 4 : 3;
  return {
    uid: `panelladikes-2027-${d.date}@fysikiepilogi.gr`,
    dtstart: `${ymd(d.date)}T${start.replace(":", "")}00`,
    dtend: `${ymd(d.date)}T${addHours(start, hours)}`,
    summary: `Πανελλαδικές ${label}: ${d.items.map((i) => i.s).join(" · ")}`,
    description: `Προσέλευση 30' πριν την έναρξη. Διάρκεια ${hours} ώρες.\nΦροντιστήριο «Φυσική Επιλογή» — fysikiepilogi.gr`,
  };
};

export function buildIcs(days, label) {
  const stamp = new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d+Z$/, "Z");
  const lines = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Fysiki Epilogi//Panelladikes 2027//EL", "CALSCALE:GREGORIAN", "METHOD:PUBLISH",
    `X-WR-CALNAME:Πανελλαδικές 2027 (${label})`, `X-WR-TIMEZONE:${TZ}`,
  ];
  days.map((d) => eventOf(d, label)).forEach((e) => {
    lines.push("BEGIN:VEVENT", `UID:${e.uid}`, `DTSTAMP:${stamp}`, `DTSTART;TZID=${TZ}:${e.dtstart}`, `DTEND;TZID=${TZ}:${e.dtend}`,
      `SUMMARY:${esc(e.summary)}`, `DESCRIPTION:${esc(e.description)}`, "LOCATION:Εξεταστικό κέντρο",
      "BEGIN:VALARM", "TRIGGER:-P1D", "ACTION:DISPLAY", "DESCRIPTION:Αύριο Πανελλαδικές!", "END:VALARM", "END:VEVENT");
  });
  lines.push("END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadIcs(days, label, filename) {
  const blob = new Blob([buildIcs(days, label)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function googleCalendarUrl(d, label) {
  const e = eventOf(d, label);
  const q = new URLSearchParams({ action: "TEMPLATE", text: e.summary, dates: `${e.dtstart}/${e.dtend}`, ctz: TZ, details: e.description, location: "Εξεταστικό κέντρο" });
  return `https://calendar.google.com/calendar/render?${q.toString()}`;
}
